import { render } from "./Key7.vue?vue&type=template&id=8a7850e4"
import script from "./Key7.vue?vue&type=script&lang=ts"
export * from "./Key7.vue?vue&type=script&lang=ts"
script.render = render

export default script